/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type EnumUserDisplayStatus = "active" | "pending" | "suspended" | "%future added value";
export type sagaWatchersViewerQueryVariables = {};
export type sagaWatchersViewerQueryResponse = {
    readonly viewer: {
        readonly roles: ReadonlyArray<string | null> | null;
        readonly firstname: string | null;
        readonly lastname: string | null;
        readonly oid_groups: ReadonlyArray<string | null> | null;
        readonly active: number | null;
        readonly filters: unknown | null;
        readonly recentlyUsedSettings: unknown | null;
        readonly displayStatus: EnumUserDisplayStatus | null;
        readonly oid_avatar: string | null;
        readonly displayPhone: string | null;
        readonly salesforceData: {
            readonly provisioning: ReadonlyArray<string | null> | null;
        } | null;
        readonly user: {
            readonly settings: unknown | null;
        } | null;
        readonly setting: {
            readonly settings: {
                readonly communication: {
                    readonly unsubscribedMessages: ReadonlyArray<unknown | null> | null;
                } | null;
            } | null;
        } | null;
    } | null;
};
export type sagaWatchersViewerQuery = {
    readonly response: sagaWatchersViewerQueryResponse;
    readonly variables: sagaWatchersViewerQueryVariables;
};



/*
query sagaWatchersViewerQuery {
  viewer {
    roles
    firstname
    lastname
    oid_groups
    active
    filters
    recentlyUsedSettings
    displayStatus
    oid_avatar
    displayPhone
    salesforceData {
      provisioning
    }
    user {
      settings
      id
    }
    setting {
      settings {
        communication {
          unsubscribedMessages
        }
      }
      id
    }
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "roles",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstname",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastname",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "oid_groups",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "active",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "filters",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "recentlyUsedSettings",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayStatus",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "oid_avatar",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayPhone",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "UserSalesforceData",
  "kind": "LinkedField",
  "name": "salesforceData",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "provisioning",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "settings",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "SettingSettings",
  "kind": "LinkedField",
  "name": "settings",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SettingSettingsCommunication",
      "kind": "LinkedField",
      "name": "communication",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "unsubscribedMessages",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "sagaWatchersViewerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v11/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Setting",
            "kind": "LinkedField",
            "name": "setting",
            "plural": false,
            "selections": [
              (v12/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "sagaWatchersViewerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v11/*: any*/),
              (v13/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Setting",
            "kind": "LinkedField",
            "name": "setting",
            "plural": false,
            "selections": [
              (v12/*: any*/),
              (v13/*: any*/)
            ],
            "storageKey": null
          },
          (v13/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c39abb4b46ae16b25b9a76068bc9f1b8",
    "id": null,
    "metadata": {},
    "name": "sagaWatchersViewerQuery",
    "operationKind": "query",
    "text": "query sagaWatchersViewerQuery {\n  viewer {\n    roles\n    firstname\n    lastname\n    oid_groups\n    active\n    filters\n    recentlyUsedSettings\n    displayStatus\n    oid_avatar\n    displayPhone\n    salesforceData {\n      provisioning\n    }\n    user {\n      settings\n      id\n    }\n    setting {\n      settings {\n        communication {\n          unsubscribedMessages\n        }\n      }\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();
(node as any).hash = '90fa204c0e110f44feb0d5efe2667b88';
export default node;
